(function () {
  if (window.customerGalleryInit) return;
  window.customerGalleryInit = true;

  var lightbox = null;
  var lightboxVideo = null;
  var lightboxImage = null;
  var lastFocus = null;

  function buildLightbox() {
    if (lightbox) return;
    lightbox = document.createElement('div');
    lightbox.className = 'customer-gallery-lightbox';
    lightbox.setAttribute('role', 'dialog');
    lightbox.setAttribute('aria-modal', 'true');
    lightbox.dataset.open = 'false';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'customer-gallery-lightbox__close';
    closeBtn.setAttribute(
      'aria-label',
      (window.customerGalleryStrings && window.customerGalleryStrings.close) || 'Close'
    );
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeLightbox);

    lightboxVideo = document.createElement('video');
    lightboxVideo.className = 'customer-gallery-lightbox__video';
    lightboxVideo.controls = true;
    lightboxVideo.playsInline = true;
    lightboxVideo.preload = 'metadata';
    lightboxVideo.style.display = 'none';

    lightboxImage = document.createElement('img');
    lightboxImage.className = 'customer-gallery-lightbox__image';
    lightboxImage.alt = '';
    lightboxImage.style.display = 'none';

    lightbox.appendChild(closeBtn);
    lightbox.appendChild(lightboxVideo);
    lightbox.appendChild(lightboxImage);

    lightbox.addEventListener('click', function (e) {
      if (e.target === lightbox) closeLightbox();
    });

    document.body.appendChild(lightbox);
  }

  function showLightbox() {
    lightbox.dataset.open = 'true';
    document.body.classList.add('customer-gallery-lightbox-open');
    document.addEventListener('keydown', onKey);
    lightbox.querySelector('.customer-gallery-lightbox__close').focus();
  }

  function openVideoLightbox(src, type, poster) {
    buildLightbox();
    lastFocus = document.activeElement;
    lightboxImage.removeAttribute('src');
    lightboxImage.style.display = 'none';
    while (lightboxVideo.firstChild) lightboxVideo.removeChild(lightboxVideo.firstChild);
    var source = document.createElement('source');
    source.src = src;
    if (type) source.type = type;
    lightboxVideo.appendChild(source);
    if (poster) lightboxVideo.poster = poster;
    lightboxVideo.style.display = '';
    lightboxVideo.load();
    showLightbox();
    try {
      lightboxVideo.play();
    } catch (e) {}
  }

  function openImageLightbox(src) {
    buildLightbox();
    lastFocus = document.activeElement;
    lightboxVideo.pause();
    while (lightboxVideo.firstChild) lightboxVideo.removeChild(lightboxVideo.firstChild);
    lightboxVideo.removeAttribute('src');
    lightboxVideo.load();
    lightboxVideo.style.display = 'none';
    lightboxImage.src = src;
    lightboxImage.style.display = '';
    showLightbox();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightboxVideo.pause();
    lightboxVideo.removeAttribute('src');
    while (lightboxVideo.firstChild) lightboxVideo.removeChild(lightboxVideo.firstChild);
    lightboxVideo.load();
    lightboxImage.removeAttribute('src');
    lightbox.dataset.open = 'false';
    document.body.classList.remove('customer-gallery-lightbox-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') closeLightbox();
  }

  function bindItems(root) {
    var items = root.querySelectorAll('[data-cg-video], [data-cg-image]');
    items.forEach(function (item) {
      if (item.__cgBound) return;
      item.__cgBound = true;
      item.addEventListener('click', function () {
        if (item.hasAttribute('data-cg-video')) {
          var src = item.getAttribute('data-cg-video-src');
          var type = item.getAttribute('data-cg-video-type');
          var poster = item.getAttribute('data-cg-poster');
          if (src) openVideoLightbox(src, type, poster);
        } else if (item.hasAttribute('data-cg-image')) {
          var src = item.getAttribute('data-cg-image-src');
          if (src) openImageLightbox(src);
        }
      });
    });
  }

  function fillTracks(root) {
    var rows = root.querySelectorAll('.customer-gallery__row');
    rows.forEach(function (row) {
      var track = row.querySelector('.customer-gallery__track');
      if (!track) return;

      if (track.__cgOriginal === undefined) {
        track.__cgOriginal = track.innerHTML;
      } else {
        track.innerHTML = track.__cgOriginal;
      }

      var items = Array.prototype.slice.call(track.children);
      if (items.length === 0) return;

      var setSize = Math.floor(items.length / 2);
      if (setSize === 0) return;
      var baseSet = items.slice(0, setSize);

      var gap = parseFloat(getComputedStyle(track).gap) || 0;

      function sumWidths(els) {
        var total = 0;
        for (var i = 0; i < els.length; i++) {
          total += els[i].getBoundingClientRect().width;
        }
        return total;
      }

      var setItemsWidth = sumWidths(baseSet);
      var setWidth = setItemsWidth + (setSize - 1) * gap;
      var stepWidth = setWidth + gap;

      if (setWidth <= 0) return;

      var viewportWidth = row.clientWidth || window.innerWidth;
      var targetTotal = viewportWidth + stepWidth;
      var currentTotal = sumWidths(track.children) + (track.children.length - 1) * gap;

      while (currentTotal < targetTotal) {
        baseSet.forEach(function (item) {
          track.appendChild(item.cloneNode(true));
        });
        currentTotal += setItemsWidth + setSize * gap;
      }

      row.style.setProperty('--cg-scroll-end', '-' + stepWidth + 'px');
    });
  }

  var visibilityObserver = null;

  function setupVisibilityFresh(root) {
    if (!('IntersectionObserver' in window)) return;
    if (visibilityObserver) visibilityObserver.disconnect();
    visibilityObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var v = entry.target;
          if (entry.isIntersecting) {
            if (v.paused) v.play().catch(function () {});
          } else {
            if (!v.paused) v.pause();
          }
        });
      },
      { rootMargin: '100px' }
    );
    root.querySelectorAll('.customer-gallery__item--video video').forEach(function (v) {
      visibilityObserver.observe(v);
    });
  }

  var mobileMQ = window.matchMedia('(max-width: 749px)');
  var reducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');

  function setupMobileScroll(root) {
    root.querySelectorAll('.customer-gallery__row').forEach(function (row) {
      if (row.__cgMobileBound) return;
      row.__cgMobileBound = true;

      var track = row.querySelector('.customer-gallery__track');
      if (!track) return;

      var direction = row.getAttribute('data-direction') === 'right' ? -1 : 1;
      var paused = false;
      var resumeTimer = null;
      var rafId = null;
      var lastTime = null;
      var floatPos = 0;

      function getStepWidth() {
        var raw = row.style.getPropertyValue('--cg-scroll-end');
        var n = parseFloat(raw);
        return isFinite(n) ? Math.abs(n) : 0;
      }

      function getPxPerSec() {
        var durRaw = getComputedStyle(track).getPropertyValue('--cg-duration');
        var dur = parseFloat(durRaw) || 60;
        if (dur <= 0) return 0;
        return 1800 / dur;
      }

      function tick(now) {
        if (lastTime === null) lastTime = now;
        var dt = (now - lastTime) / 1000;
        lastTime = now;

        if (!paused && !reducedMotionMQ.matches) {
          var step = getStepWidth();
          var pxPerSec = getPxPerSec();
          if (step > 0 && pxPerSec > 0) {
            floatPos += pxPerSec * dt * direction;
            if (floatPos >= step) floatPos -= step;
            if (floatPos < 0) floatPos += step;
            row.scrollLeft = floatPos;
          }
        }

        if (mobileMQ.matches) {
          rafId = requestAnimationFrame(tick);
        } else {
          rafId = null;
        }
      }

      function pauseScroll() {
        paused = true;
        if (resumeTimer) clearTimeout(resumeTimer);
      }

      function scheduleResume() {
        if (resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function () {
          paused = false;
          floatPos = row.scrollLeft;
          lastTime = null;
        }, 2000);
      }

      row.addEventListener('touchstart', pauseScroll, { passive: true });
      row.addEventListener('touchend', scheduleResume, { passive: true });
      row.addEventListener('touchcancel', scheduleResume, { passive: true });
      row.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'mouse') pauseScroll();
      });
      row.addEventListener('pointerup', function (e) {
        if (e.pointerType === 'mouse') scheduleResume();
      });

      function start() {
        if (rafId === null && mobileMQ.matches) {
          lastTime = null;
          if (direction === -1) {
            var step = getStepWidth();
            if (step > 0 && row.scrollLeft === 0) row.scrollLeft = step;
          }
          floatPos = row.scrollLeft;
          rafId = requestAnimationFrame(tick);
        }
      }

      function stop() {
        if (rafId !== null) {
          cancelAnimationFrame(rafId);
          rafId = null;
        }
      }

      mobileMQ.addEventListener('change', function (e) {
        if (e.matches) start();
        else stop();
      });

      if (mobileMQ.matches) start();
    });
  }

  function init(root) {
    fillTracks(root);
    bindItems(root);
    setupVisibilityFresh(root);
    setupMobileScroll(root);
  }

  function initAll() {
    document.querySelectorAll('.customer-gallery__marquee').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(initAll, 250);
  });

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.customer-gallery__marquee');
    if (section) init(section);
  });
})();
